//export const dev_env_path = 'https://apidev.cov.n3r.com.br';
//export const prod_env_path = 'https://api.cov.n3r.com.br';
//export const default_server = 'https://api.cov.n3r.com.br';
export const default_server =  process.env.REACT_APP_DEFAULT_SERVER;
